@let energyLabelsValue = energyLabels();
@let improvedEnergyLabelsValue = improvedEnergyLabels();
@if (energyLabelsValue && improvedEnergyLabelsValue) {
  <h2>{{ title() | translate }}</h2>
  <div>
    <p
      [innerHtml]="
        (description() || `energyLabel.ratings.description.${labelGroup()}`)
          | translate
            : {
                currentPercentage: currentPercentageGreenLabels(),
                improvedPercentage: improvedPercentageGreenLabels(),
                subDescription: subDescription()
              }
      "
    ></p>
    <label class="fw-bold small">{{ currentDistributionTitle() | translate }}</label>
    <cfp-energy-label-distribution [energyLabels]="energyLabelsValue" [showLabel]="showLabel()" />
    <label class="fw-bold small mt-4">{{ improvedDistributionTitle() | translate }}</label>
    <cfp-energy-label-distribution [energyLabels]="improvedEnergyLabelsValue" [showLabel]="showLabel()" />
  </div>
  <div class="mt-4">
    <cfp-legend>
      @for (label of legendEnergyLabels(); track label) {
        <cfp-legend-item [label]="label.translation" [colorClass]="label.colorClass"></cfp-legend-item>
      }
    </cfp-legend>
  </div>
}
